import React, { PropsWithChildren } from "react";
import { RegisterOptions, useFormContext } from "react-hook-form";

interface Props {
  name: string;
  required?: boolean;
  className?: string;
  options?: RegisterOptions;
}

const Checkbox: React.FC<PropsWithChildren<Props>> = (
  props,
): React.ReactElement => {
  const { register, getFieldState } = useFormContext();

  const { invalid, isDirty, error } = getFieldState(props.name);

  return (
    <div>
      <div
        className={`checkbox-wrapper flex items-start ${invalid ? "invalid" : ""}`}
      >
        <div className="checkbox">
          <input type="checkbox" {...register(props.name, props.options)} />
        </div>
        <label
          className="text-secondary ml-4 text-[14px] leading-[24px]"
          htmlFor={props.name}
        >
          <slot>{props.children}</slot>
        </label>
      </div>
      {error && isDirty && (
        <div className="text-error mt-1 text-[13px]">{error.message}</div>
      )}
    </div>
  );
};

export default Checkbox;
